module.exports = __webpack_public_path__ + "static/media/elo_hero_mobile.281af663.webp";